import { Component } from '@angular/core';

@Component({
  selector: 'app-lastnavbar',
  standalone: true,
  imports: [],
  templateUrl: './lastnavbar.component.html',
  styleUrl: './lastnavbar.component.scss'
})
export class LastnavbarComponent {

}
